import { AangevraagdeLandelijkeFaciliteiten, usePatchLandelijkeFaciliteiten } from "@/entities/vestiging";
import { LandelijkeFaciliteitenHeader, LandelijkeFaciliteitenRow } from "@/features/faciliteiten/components/shared/landelijk";
import { ConfirmDialog, Separator } from "@/shared/components";
import { useMemo, useState } from "react";
import { ToelichtingDialog } from "../shared/toelichting-dialog";
import { RespondToAanvraagAction } from "./respond-to-aanvraag-action.tsx";

type LandelijkeFaciliteitenKlantenserviceProps = {
    dossierId: string;
    aanvraag: AangevraagdeLandelijkeFaciliteiten | null;
};

export function LandelijkeFaciliteitenKlantenservice({ dossierId, aanvraag }: LandelijkeFaciliteitenKlantenserviceProps) {
    const [toelichting, setToelichting] = useState<string | undefined>();
    const [confirmDialogGaatNietLeverenOpen, setConfirmDialogGaatNietLeverenOpen] = useState<boolean>(false);
    const [toelichtingDialogOpen, setToelichtingDialogOpen] = useState<boolean>(false);

    const { mutate: patchLandelijkeFaciliteiten, isPending, error } = usePatchLandelijkeFaciliteiten();

    const aanvraagStatus = aanvraag?.status;
    const klantenserviceActions = useMemo(
        () => [
            { label: "Gaat niet leveren", action: () => setConfirmDialogGaatNietLeverenOpen(true), enabled: aanvraagStatus === "Besteld" },
            {
                label: "Toelichting toevoegen",
                action: () => setToelichtingDialogOpen(true),
                enabled: aanvraagStatus === "Besteld" || aanvraagStatus === "StopAangevraagd",
            },
        ],
        [aanvraagStatus]
    );

    const sendGaatNietLeverenRequest = () => {
        patchLandelijkeFaciliteiten(
            { dossierId, status: "GaatNietLeveren", toelichting },
            { onSuccess: () => setConfirmDialogGaatNietLeverenOpen(false) }
        );
    };

    const saveToelichting = (toelichting: string) => {
        setToelichting(toelichting);
        setToelichtingDialogOpen(false);
    };

    return (
        <div className="grid gap-6 pt-4">
            <LandelijkeFaciliteitenHeader readOnly />
            <Separator orientation="horizontal" />
            <LandelijkeFaciliteitenRow
                status={aanvraag?.status}
                toelichting={aanvraag?.toelichting ?? toelichting}
                actions={klantenserviceActions}
            />
            <RespondToAanvraagAction dossierId={dossierId} status={aanvraag?.status} toelichting={toelichting} />
            <ConfirmDialog
                isOpen={confirmDialogGaatNietLeverenOpen}
                onCancel={() => setConfirmDialogGaatNietLeverenOpen(false)}
                onConfirm={sendGaatNietLeverenRequest}
                isPending={isPending}
                error={error}
                title="Landelijke faciliteiten gaan niet leveren"
                confirmLabel="Gaat niet leveren"
                destructive
            >
                Weet je zeker dat deze faciliteit niet gaat leveren? Deze keuze kun je niet ongedaan maken.
            </ConfirmDialog>
            <ToelichtingDialog
                open={toelichtingDialogOpen}
                onOpenChange={setToelichtingDialogOpen}
                titelSuffix="landelijke faciliteiten"
                existingToelichting={toelichting}
                onSave={saveToelichting}
            />
        </div>
    );
}
